export const APP = "LaHeroica"    
export const API_URL = "https://server.c5ciudadano.com"
export const APPWEB_VERSION = "1.01"
export const CLAVE_MUNICIPIO = '112'
export const MUNICIPIO = 'Zitacuaro'